import { bemBuilder } from "@chatfood/core-utils";

const className = "layouts-web-responsive";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
